import { resolveLanguage, type SupportedLanguage } from './storage';

/**
 * Which language wins after sign-in (B1):
 *
 * - Signed out: the visitor's explicit choice (`ui.languagePreview`, written by
 *   the Help toggle) and then `hc_language`.
 * - Brand-new account (right after registration): its settings were never
 *   customised, so the backend default `en` is not a choice. The first
 *   settings load sends the language the visitor was using to the account
 *   (`languageToSeed`), so registering in Arabic lands in Arabic.
 * - Existing account (login, any later visit): the language saved on the
 *   account always wins. A local choice made on a public page before logging
 *   in is dropped on the first settings load, and `hc_language` is rewritten
 *   with the account language.
 */
export function languageToSeed(
  localLanguage: SupportedLanguage | null,
  accountLanguage: string | null | undefined
): SupportedLanguage | null {
  if (!localLanguage) {
    return null;
  }
  return localLanguage === resolveLanguage(accountLanguage)
    ? null
    : localLanguage;
}
